import { MouseEventHandler, ReactNode } from "react";
import clsx from "clsx";

import SizeOptions from "../../types/system/SizeOption";

export interface ButtonProps {
  children?: ReactNode;
  type?: "submit" | "reset" | "button";
  className?: string;
  fullWidth?: boolean;
  variant?: "contained" | "outlined";
  size?: SizeOptions;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
}

export function Button({
  children,
  className,
  type = "button",
  fullWidth = false,
  variant = "contained",
  size = "md",
  onClick,
  disabled = false,
}: ButtonProps) {
  let sizeClass: String;
  let styleClass: String;

  switch (size) {
    case "xs":
      sizeClass = "px-1 py-0.5 text-xs";
      break;
    case "sm":
      sizeClass = "px-2 py-1 text-sm";
      break;
    case "lg":
      sizeClass = "px-3.5 py-2.5 font-medium text-md";
      break;
    default:
      sizeClass = "px-3 py-2 font-medium text-sm";
      break;
  }

  if (variant === "contained") {
    styleClass =
      "bg-orange-600/80 text-white border border-orange-600/80 hover:bg-orange-600 hover:border-orange-600 active:border-orange-600/90 active:bg-orange-600/90";
  } else {
    styleClass =
      "border border-orange-600 text-gray-700 hover:bg-orange-600/20 active:bg-orange-600/10";
  }

  return (
    <button
      type={type}
      onClick={disabled ? () => {} : onClick}
      className={clsx(
        "rounded",
        fullWidth && "w-full",
        sizeClass,
        styleClass,
        className,
        disabled &&
          "!bg-gray-200 !border-gray-200 !text-gray-400 dark:!bg-gray-400 dark:!border-gray-400 dark:!text-gray-600",
      )}
    >
      {children}
    </button>
  );
}
